import React, { useContext, useState } from "react"
import { StateContext } from "../../../../context/StateContext"
import Header from "../../../../components/header/header"
import Template from "./Template"
import { MelodiesContextProvider } from "../../../../context/MelodiesContext"
import { TemplatesContext } from "../../../../context/TemplatesContext"
import axios from "axios"
import { useToasts } from "react-toast-notifications"
import Loading from "../../../../components/loading/loading"

/**
 * Список программ (шаблонов).
 */
const Templates = () => {
    const STATE = useContext(StateContext)
    const { templatesTitles, renameTemplate } = useContext(TemplatesContext)

    const { addToast } = useToasts()

    const [templates] = useState(STATE.lastData.templates)

    /**
     * Сохранит программы.
     */
    const saveTemplate = (templateIndex, slots, title) => {
        if (title) {
            const data = {
                template_id: templates[templateIndex].id,
                title: title.trim()
            }

            axios
                .post(`/templates/${STATE.lastData.deviceId}`, data)
                .then(() => {
                    renameTemplate(data.template_id, data.title)
                })
                .catch((error) => {
                    addToast(
                        error?.response?.data?.error?.title ?? error.message,
                        {
                            appearance: "error",
                            autoDismiss: true,
                        }
                    )
                })
        }

        const newTemplates = [...STATE.lastData.templates]

        newTemplates[templateIndex] = { ...templates[templateIndex] }

        STATE.sendData({ templates: newTemplates })
    }

    let templatesList = <Loading />

    if (Object.keys(templatesTitles).length > 0) {
        templatesList = templates.map((template, index) => {
            return (
                <Template
                    key={template.id}
                    originalTemplate={template}
                    originalTitle={templatesTitles[template.id]}
                    saveTemplate={(slots, title = null) => saveTemplate(index, slots, title)}
                    isSending={STATE.isSending}
                />
            )
        })
    }

    return (
        <div className="main-area-field full-height">
            <div className="main-area full-height">
                <div className="page-area no-p">
                    <Header
                        title={"Программы"}
                        backTitle="Настройки"
                        backUrl={`/device/${STATE.subscribed.id}/settings`}
                    />

                    <MelodiesContextProvider>
                        <div className="page-area center-h">
                            <div className="chimes-content">
                                {templatesList}
                            </div>
                        </div>
                    </MelodiesContextProvider>
                </div>
            </div>
        </div>
    )
}

export default Templates